// @flow
import JQueryView, { on } from '../../common/JQueryView';
import { restrictionHandling } from '../../../models/external_service_access_restrictions/ExternalServiceAccessRestriction';

export default class IndexView extends JQueryView {
  constructor() {
    super('.index');
  }

  @on({
    event: 'click',
    selector: 'button.to-new-company-electro-contract',
  })
  onClickToNewCompanyElectroContract(event: SyntheticEvent<HTMLButtonElement>) {
    const to = event.currentTarget.dataset.to;
    restrictionHandling('WAN-Sign', () => {
      window.location = to;
    });
  }
}
